<template>
  <div class="results" id="Results">
    <!-- DO NOT REMOVE WILL BREAK -->

    <b-row class="title">
      <b-col cols='8' :class="{homeTitleWidget : home == true}">
        <div class="title main TournamentTitle" >
          <template v-if="home == true">
            <span class="reportWidget_title">Final Result</span>
          </template>
          <template v-if="config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
            <template >
              <p :class="{WidgetStyle: home == true}">{{data.full_name}} <span v-if="home != true">- {{title}}</span></p>
            </template>
          </template>
          <template v-else>
            <p :class="{WidgetStyle: home == true}">{{data.full_name}}</p>
          </template>
        </div>
      </b-col>
      <b-col :class="{HomeHide: home == true}" cols='4'>
        <div class="sponLogo">
          <!-- <i v-b-toggle.collapse-1 class="fa-solid fa-circle-info"></i> -->
          <template v-if="config.VUE_APP_ID == 'bvt' || config.VUE_APP_TOUR == 'let' || config.VUE_APP_ID == 'sst'">
            <img class="informationImg" v-b-toggle="'collapse-1'" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/Information.png">
          </template>
          <template v-else>
            <i
              v-b-toggle="'collapse-1'"
              class="fa-solid fa-circle-info"
            ></i>
          </template>
        </div>
      </b-col>
    </b-row>
    <template v-if="show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <div :class="{reportsHide: home == false}" class="gradHome"></div>
    <!-- DO NOT REMOVE WILL BREAK -->
    <template v-if="data.playoff == 'Y'">
      <div class="redBanner">
        PlayOff Winner: {{data.playoff_winner}}
      </div>
    </template>
    <table class="results-table" :class="{resultsHome : home == true, reportsHome : home == true}">
      <thead :class="{HomeHide: home == true}">
        <tr>
          <template v-if="tablePick === 'Final'">
            <th>
              Pos
            </th>

            <th class="LeftAlign">
              Name
            </th>
            <th class="mobNone" :class="{noNat : home == true}">
              <span>Nat</span>
            </th>
            <template v-if="dataShowOOM != 'B'">
              <th>
                <span v-show="dataShowOOM == 'Y' && is_qualifier == 'N'"
                  >Winnings</span
                >
                <span v-show="dataShowOOM == 'P'">
                  <span v-if="dataShowPointsName == ''">Points</span>
                  <span v-else>
                    <span v-if="dataShowPointsName === 'Order of Merit'">
                      OoM
                    </span>
                    <span v-else>
                      {{ dataShowPointsName }}
                    </span>
                  </span>
                </span>
              </th>
            </template>
            <th v-show="dataShowOOM == 'B'" class="mobNone">Winnings</th>
            <th v-show="dataShowOOM == 'B' && dataHavePoints == 'Y'" class="mobNone">
              <span v-if="dataShowPointsName === 'Order of Merit'">
                OoM
              </span>
              <span v-else>
                {{ dataShowPointsName }}
              </span>
            </th>
            <template v-if="match === 'N'">
              <th class="" v-show="Stableford == 'N'">
                Par
              </th>
              <th class="mobNone" v-if="this.roundsPlayed < 1"></th>
              <th
                class="mobNone"
                v-else-if="this.roundsPlayed > 1"
                v-for="(i, roundIt) in range(1, roundsPlayed)"
                :key="roundIt"
                :class="{redPlayoff : data.playoff == 'Y' && i == data.playoff_round_num}"
              >
                  <span
                    v-if="data.playoff == 'Y' && i == data.playoff_round_num
                    "
                    >Playoff</span
                  >
                  <span v-else>R{{ i }}</span>
              </th>
              <th >
                Score
              </th>
            </template>
            <template>
              <th class="hidden-xs" v-if="dataHaveOom == 'Y'">OOM Points</th>
            </template>
            <th class="mobNone" v-if="config.VUE_APP_PLAYER_ICON === 'Y'"></th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template v-for="(tabledata, index) in Eds">
          <tr v-if="tabledata.pos == 'EOQ'" :key="tabledata.pos">
            <td colspan="11" class="cut">{{ tabledata.pos }}</td>
          </tr>
          <tr
            v-else
            @click.stop="rowClicked(index)"
            :key="index"
            :class="{
              drawNoborder: tablePick === 'Draw',
              homeResult: home === true,
              homeTr: home == true
            }"
          >
            <template v-if="tablePick === 'Final'">
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.pos }}
              </td>
              <td class="posnum" v-else-if="index !== 0" :class="{homeposnum : home == true}">
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td class="posnum" v-else-if="index === 0" :class="{homeposnum : home == true}">
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td v-else class="noPos"><span>.</span></td>

              <td
                v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT'"
                @click="playerCard(tabledata.id)"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down'
                }"
                class="LeftAlign"
              >
                <!-- <a :href="'/playerprofile/' + tabledata.member_no"> -->
                <span v-if="data.result_type === 'TF'">
                  <span
                    v-if="data.team_event === 'Y' || title.includes('Team')"
                  >
                    {{ tabledata.name }}
                  </span>
                  <span v-else>
                    {{ tabledata.name }}
                  </span>
                </span>
                <span v-else>
                  <template v-if="home == true && config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
                    <template v-if="tabledata.profile == 'Y'">
                      <b-link :to="'/playerprofile/' + tabledata.member_no" class="removeUnderLineHome">
                        <span class="initialHome">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname}}</span>
                        <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                      </b-link>
                    </template>
                    <template v-else>
                      <span class="initialHomeNone">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname}}</span>
                      <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                    </template>
                  </template>
                  <template v-else>
                    {{ tabledata.playing_name }}
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </template>
                </span>
                <span v-if="tabledata.sponsored === 'Y' && home == false"
                  ><b-img :src="config.VUE_APP_TITLEIST"></b-img
                ></span>
                <span v-if="tabledata.entry_sponsored === 'Y'"
                  ><b-img
                    style="width: 15px; margin-left: 13px;"
                    src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                  ></b-img
                ></span>
                <span
                  v-if="showGender === 'Y'"
                  class="multiDot-size-reportgender"
                  :class="{
                    female: tabledata.gender === 'F',
                    male: tabledata.gender === 'M'
                  }"
                  >•</span
                >
                <!-- </a> -->
              </td>
              <td class="mobHide mobNone" v-if="tabledata.pos !== 'CUT'" :class="{noNat : home == true}">
                <span v-if="tabledata.nationality === ''"></span>
                <span v-else>
                  <template v-if="data.represents_flag_type === 'N'">
                    {{ tabledata.nationality }}
                  </template>
                  <template v-else>
                    <img
                      class="flag"
                      :src="
                        (config.VUE_APP_FLAG_URL + tabledata.nationality)
                          | lowercase
                      "
                    />
                  </template>
                </span>
              </td>
              <td v-if="tabledata.pos !== 'CUT' && dataShowOOM != 'B'" class="">
                <span v-show="dataShowOOM == 'Y' && is_qualifier == 'N'"
                  >{{ tabledata.winnings }}
                </span>
                <span v-show="dataShowOOM == 'P'">{{
                  tabledata.winnings
                }}</span>
              </td>
              <td v-if="tabledata.pos !== 'CUT' && dataShowOOM == 'B'" class="mobNone">
                <span>{{ tabledata.winnings }}</span>
              </td>
              <td
                class="mobNone"
                v-if="
                  tabledata.pos !== 'CUT' &&
                    dataShowOOM == 'B' &&
                    dataHavePoints == 'Y'
                "
              >
                {{ tabledata.points_both }}
              </td>

              <template v-if="match === 'N' && tabledata.pos !== 'CUT'">
                <td
                  v-if="tabledata.vspar < 0 && Stableford == 'N'"
                  class="up"
                >
                  {{ tabledata.vspar }}
                </td>
                <td
                  v-else-if="tabledata.vspar > 0 && Stableford == 'N'"
                  class="down"
                >
                  {{ tabledata.vspar }}
                </td>
                <td
                  v-else-if="tabledata.pos !== 'CUT' && Stableford == 'N'"
                  class=""
                >
                  {{ tabledata.vspar }}
                </td>
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  class="MTest mobNone"
                >
                  <span
                    v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                    class="up"
                    >{{ tabledata.score }}</span
                  >
                  <span
                    v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                    class="down"
                    >{{ tabledata.score }}</span
                  >
                  <span v-else-if="roundsPlayed === 1">{{
                    tabledata.score
                  }}</span>
                  <span v-else-if="tabledata['score_R' + i] < data.course_total_par.slice(1)" :class="up">{{
                    tabledata["score_R" + i]
                  }}</span>
                  <span
                    v-else-if="tabledata['score_R' + i] > data.course_total_par.slice(1)"
                    :class="down"
                    >{{ tabledata["score_R" + i] }}</span
                  >
                  <span v-else class="parColor">{{ tabledata["score_R" + i] }}</span>
                </td>
                <td v-if="tabledata.vspar < 0 && roundsPlayed > 1" class="up">
                  {{ tabledata.score }}
                </td>
                <td
                  v-else-if="tabledata.vspar > 0 && roundsPlayed > 1"
                  class="down"
                >
                  {{ tabledata.score }}
                </td>
                <td v-else-if="roundsPlayed > 1" class="">
                  {{ tabledata.score }}
                </td>
              </template>
              <template v-if="tabledata.pos !== 'CUT'">
                <td v-if="dataHaveOom == 'Y'">
                  {{ tabledata.points }}
                </td>
              </template>
              <td
                class="mobNone"
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    tabledata.pos !== 'CUT' &&
                    config.VUE_APP_PLAYER_ICON === 'Y'
                "
              >
                <template v-if="tabledata.profile == 'Y'">
                  <a :href="'/playerprofile/' + tabledata.member_no">
                    <span class="playerInfo">
                      <!-- Player Info -->
                      <span class="iconRight">
                        <font-awesome-icon
                          class="icon"
                          :icon="['fa', 'chevron-right']"
                        />
                      </span>
                    </span>
                  </a>
                </template>
              </td>
            </template>
          </tr>
          <tr
            @click.stop="rowClicked(rowClicked === -1)"
            v-if="index === clickedRow"
            class="tr-kids"
            :class="{homeTRKids : home == true}"
            :key="index + Math.random()"
          >
            <td id="reportCard" colspan="11">
              <PlayerReportCard
                :data="data"
                :Stableford="Stableford"
                :playerCardData="playerCardData"
                :config="config"
                :develop="develop"
                :actualRound="data.pft_round"
                :roundsPlayed="roundsplayed"
                :scoreType="data.scores_type"
                :team="team"
                :courses="courses"
                :tmparams="tmparams"
                :sg_avg="sg_avg"
                :hide_sg_sc="hide_sg_sc"
                :driving_dist="driving_dist"
                :drive_acc="drive_acc"
                :sand_saves="sand_saves"
                :gir="gir"
                :putting_ave="putting_ave"
                :pgir="pgir"
                :id="id"
                :hole_by_hole="hole_by_hole"
              />
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
// import apiCall from "@/services/api.js";
import Information from "@ocs-software/vue-ocs/ocs/reports/information.vue";
import PlayerReportCard from "./scorecards/components/orginalReportCard.vue";
export default {
  name: "Results",
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "season",
    "code",
    "tour",
    "team",
    "config",
    "develop",
    "match",
    "dataShowOOM",
    "dataHavePoints",
    "dataShowPointsName",
    "dataHaveOom",
    "showGender",
    "is_qualifier",
    "Stableford",
    "roundsplayed",
    "showmore",
    "show_info_web",
    "hide_score_card",
    "id",
    "hole_by_hole"
  ],
  components: { 
    PlayerReportCard,
    Information
  },
  data() {
    return {
      cardID: [],
      compare: [],
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      playerCardData: [],
      win: "win"
    };
  },
  methods: {
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.home == true) {
        console.log('test')
      } else {
        if (this.tablePick === "Final" && this.clickedRow !== index)
          this.clickedRow = index;
        else this.clickedRow = -1; 
      }
    },
    playerCard: function(playerNo) {
      var playerData = {};
      console.log("playerData");
      console.log(playerData);
      var cardID = playerNo;
      console.log("cardID");
      console.log(cardID);
      for (var i of this.data.result.result_entry) {
        console.log("in scores");
        if (i.member_no == playerNo) {
          this.playerData = i;
          // console.log("playerData 998");
          // console.log(this.playerData);
          break;
        }
      }
      if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt') {
        if (this.id == '') {
         return (
          // (this.cardID = cardID),
          axios
            .get(
              process.env.VUE_APP_API +
                'apga'
                +
                '/cache/' 
                +
                this.develop
                +
                '/'
                +
                this.season +
                "/" +
                this.season +
                "-" +
                this.code +
                "-cards-" +
                cardID +
                ".json?randomadd=" +
                new Date().getTime()
            )
            .then(
              response => (
                (this.playerCardData = response.data),
                (this.sg_avg = response.data.sg_avg),
                (this.hide_sg_sc = response.data.hide_sg_sc)
              )
            )
        );         
        } else {
          return (
            // (this.cardID = cardID),
            axios
              .get(
                process.env.VUE_APP_API +
                  'apga'
                  +
                  '/cache/' 
                  +
                  this.develop
                  +
                  '/'
                  +
                  this.id +
                  "/" +
                  this.id +
                  "-" +
                  this.code +
                  "-cards-" +
                  cardID +
                  ".json?randomadd=" +
                  new Date().getTime()
              )
              .then(
                response => (
                  (this.playerCardData = response.data),
                  (this.sg_avg = response.data.sg_avg),
                  (this.hide_sg_sc = response.data.hide_sg_sc)
                )
              )
          ); 
          }
      } else {
        return (
          // (this.cardID = cardID),
          axios
            .get(
              process.env.VUE_APP_APIFULL_URL +
                this.season +
                "/" +
                this.season +
                "-" +
                this.code +
                "-cards-" +
                cardID +
                ".json?randomadd=" +
                new Date().getTime()
            )
            .then(
              response => (
                (this.playerCardData = response.data),
                (this.sg_avg = response.data.sg_avg),
                (this.hide_sg_sc = response.data.hide_sg_sc)
              )
            )
        );
      }
    }
  },
  computed: {
    tablePick: function(picked) {
      if (this.title === "Tournament Entries") picked = "Entries";
      else if (this.title.includes("Draw")) picked = "Draw";
      else if (
        (this.title.includes("Scores") && this.data.live_scoring === "N") ||
        (this.title.includes("Scoreboard") && this.data.live_scoring === "N")
      )
        picked = "Score";
      else if (
        (this.title.includes("Scores") && this.data.live_scoring === "Y") ||
        (this.title.includes("Scoreboard") && this.data.live_scoring === "Y")
      )
        picked = "Live";
      else if (this.title.includes("Final")) picked = "Final";
      else if (this.title.includes("Live")) picked = "Live";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    Eds(reportData) {
      if (this.home === false) {
        if (this.title.includes("Final") || this.title.includes("Statistics"))
          if (Array.isArray(this.data.result.result_entry)) {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = this.data.result.result_entry.slice(0,10);
              } else {
                reportData = this.data.result.result_entry;
              }
            } else {
              reportData = this.data.result.result_entry;
              console.log("One");
            }
          } else {
             if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = [this.data.result.result_entry].slice(0,10);
              } else {
                reportData = [this.data.result.result_entry];
              }
             } else {
              reportData = [this.data.result.result_entry];
              console.log("Two");
             }
          }
        // reportData = this.data.result.result_entry;
        return reportData;
      } else {
        if (this.title.includes("Final") || this.title.includes("Statistics"))
          if (Array.isArray(this.data.result.result_entry)) {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt') {
              reportData = this.data.result.result_entry;
              console.log("One"); 
            } else {
              reportData = this.data.result.result_entry.slice(0, 4);
              console.log("One");
            }
          } else {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt') {
              reportData = [this.data.result.result_entry];
              console.log("Two");
            } else {
              reportData = [this.data.result.result_entry].slice(0, 4);
              console.log("Two"); 
            }
          }
        // reportData = this.data.result.result_entry.slice(0, 6);
        return reportData;
      }
    }
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      console.log(newValue);
    },
    immediate: true,
    deep: true
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  }
};
</script>
<style>
.redBanner {
    background-color: red;
    text-align: center;
    color: #fff;
}
th.mobNone.redPlayoff {
  background-color: red!important;
  border-top:1px solid rgb(255, 255, 255);
}

</style>
